// extracted by mini-css-extract-plugin
module.exports = {"NouveautesList":"NouveautesList_NouveautesList__3iQuN","areaOfNouveautes":"NouveautesList_areaOfNouveautes__31RBB","divButtons":"NouveautesList_divButtons__3fR8J"};